"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportWithdrawApprove = reportWithdrawApprove;
exports.reportWithdrawBatch = reportWithdrawBatch;
exports.reportWithdrawDepositRefund = reportWithdrawDepositRefund;
exports.reportWithdrawReject = reportWithdrawReject;
var _adminOperationReport = require("@/utils/adminOperationReport");
/**
 * 【操作埋点】提现管理模块上报方法
 * 实施时间：2026-05-25
 * 说明：审核通过/驳回/批量/押金退还
 */

/**
 * 审核通过提现埋点上报
 * @param {number} withdrawId - 提现单ID
 * @param {number} amount - 提现金额
 * @param {string} agentName - 代理/商户名称
 */
function reportWithdrawApprove(withdrawId, amount, agentName) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '审核通过提现',
    content: "\u5BA1\u6838\u901A\u8FC7\u300C".concat(agentName, "\u300D\u63D0\u73B0\u7533\u8BF7\uFF0C\u5355\u53F7\uFF1A").concat(withdrawId, "\uFF0C\u91D1\u989D\uFF1A").concat(amount, "\u5143"),
    operation_id: 'pc_withdraw_approve_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_withdraw_approve_1');
}

/**
 * 拒绝提现埋点上报
 * @param {number} withdrawId - 提现单ID
 * @param {string} reason - 拒绝原因
 * @param {string} agentName - 代理/商户名称
 */
function reportWithdrawReject(withdrawId, reason, agentName) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '拒绝提现',
    content: "\u62D2\u7EDD\u300C".concat(agentName, "\u300D\u63D0\u73B0\u7533\u8BF7\uFF0C\u5355\u53F7\uFF1A").concat(withdrawId, "\uFF0C\u539F\u56E0\uFF1A").concat(reason),
    operation_id: 'pc_withdraw_reject_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_withdraw_reject_1');
}

/**
 * 批量提现埋点上报
 * @param {Array} withdrawIds - 提现单ID列表
 * @param {number} totalAmount - 总金额
 */
function reportWithdrawBatch(withdrawIds, totalAmount) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '批量审核提现',
    content: "\u6279\u91CF\u5904\u7406 ".concat(withdrawIds.length, " \u7B14\u63D0\u73B0\u7533\u8BF7\uFF0C\u603B\u91D1\u989D\uFF1A").concat(totalAmount, "\u5143"),
    operation_id: 'pc_withdraw_batch_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_withdraw_batch_1');
}

/**
 * 【操作埋点】2026-05-25 退还用户押金（cashpledge 页）
 */
function reportWithdrawDepositRefund(orderId, taskId) {
  var payType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '微信';
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '退还押金',
    content: "\u901A\u8FC7".concat(payType, "\u9000\u8FD8\u62BC\u91D1\uFF0C\u8BA2\u5355ID ").concat(orderId, "\uFF0C\u4EFB\u52A1ID ").concat(taskId || '无'),
    operation_id: 'pc_withdraw_deposit_refund_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_withdraw_deposit_refund_1');
}